// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__2cVKZ","footer":"ModalUpdate_footer__398HH"};